import React from 'react'

import { Outcome } from '@app/graphql/types'
import { CheckResultsLayout } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsLayout'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'

export type DeadlinesCheckResultsProps = {
  check: UtilityBillAnalysisChecks['deadlines']
}

export const DeadlinesCheckResults = ({ check }: DeadlinesCheckResultsProps) => {
  if (check.outcome === Outcome.Pass) {
    return null
  }

  return (
    <CheckResultsLayout>
      <CheckResultsLayout.Title>Fristwahrung</CheckResultsLayout.Title>
      <CheckResultsLayout.Description>
        Die Abrechnungsfrist von 12 Monaten nach Ablauf des Abrechnungszeitraums ist abgelaufen.
      </CheckResultsLayout.Description>
    </CheckResultsLayout>
  )
}
